import { Component, inject, model, viewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { EmailContact } from '../../../models';
import { ModalService } from '../../../services';
import { GridService } from '../../../services/component-services/grid.service';
import { GridComponent } from '../../grids/grid/grid.component';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

/**
 * The customer/supplier contact picker for the email modal — the list the old screen showed
 * as a permanent "Email Contacts" grid, now opened by the Contacts… link on the Cc row.
 * Closes with the ticked contacts; the modal adds them to Cc as chips, which is exactly what
 * the old grid's selection did on send, just visibly and reversibly.
 */
@Component({
  selector: 'app-email-contact-picker-modal',
  templateUrl: './email-contact-picker-modal.component.html',
  styleUrl: './email-contact-picker-modal.component.scss',
  imports: [GridComponent, SummaryTopComponent],
})
export class EmailContactPickerModalComponent {
  private readonly gridService = inject(GridService);
  private readonly modalService = inject(ModalService);

  private readonly grid = viewChild<GridComponent>('contactsGrid');

  public readonly contacts = model<EmailContact[]>([]);

  protected readonly header = $localize`Email Contacts`;

  protected readonly columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('forename', $localize`Forename`, true),
    this.gridService.text('surname', $localize`Surname`),
    this.gridService.text('email', $localize`Email`),
  ];

  protected onAdd() {
    this.modalService.close(this.grid()?.selectedRows ?? []);
  }

  protected onCancel() {
    this.modalService.dismiss();
  }
}
